import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { CheckCircle2, Clock, FileText } from 'lucide-react';

export interface StatusCard {
  title: string;
  value: string;
  subtitle: string;
  icon: 'clock' | 'check' | 'file';
  iconColor: 'yellow' | 'green' | 'blue';
}

interface KycStatusCardsProps {
  cards: StatusCard[];
}

const KycStatusCards = ({ cards }: KycStatusCardsProps) => {
  const getIcon = (icon: StatusCard['icon']) => {
    switch (icon) {
      case 'clock':
        return <Clock className="h-8 w-8 text-yellow-500" />;
      case 'check':
        return <CheckCircle2 className="h-8 w-8 text-green-500" />;
      case 'file':
        return <FileText className="h-8 w-8 text-blue-500" />;
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {cards.map((card, index) => (
        <Card key={index}>
          <CardHeader>
            <CardTitle className="text-sm font-medium">{card.title}</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex items-center gap-3">
              <div className="flex-shrink-0">{getIcon(card.icon)}</div>
              <div>
                <div className="text-2xl font-bold">{card.value}</div>
                <div className="text-sm text-muted-foreground">
                  {card.subtitle}
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default KycStatusCards;
